import getAccountSourceListStore from '../store/accountSourceListStore';

export default function getIdentities(): string[] {
    return getAccountSourceListStore().identities;
}
